<template>
  <div class="basic_wrap record-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('user.withdrawalRecord') }}
      </div>
      <button
        type="button"
        class="top_right top-action"
        @click="$router.push('/moneybag')"
      >
        <van-icon name="filter-o" />
      </button>
    </div>

    <van-empty
      v-if="listShow"
      :description="$t('moneybag.detailsEmpty')"
    />
    <div
      v-else
      class="record-list"
    >
      <article
        v-for="(item, index) in records"
        :key="item.id || item.time || index"
        class="record-card"
      >
        <div class="record-head">
          <div class="record-title">
            {{ $t('shopds.money') }}
          </div>
          <strong class="record-money is-outcome">
            {{ formatMoney(item.money) }}
          </strong>
        </div>
        <div class="record-row">
          <span>{{ $t('shopds.time') }}</span>
          <time>{{ item.time }}</time>
        </div>
        <div class="record-row status-row">
          <strong
            class="record-status"
            :class="getCashStatusClass(item)"
          >
            {{ getCashStatusText(item) }}
          </strong>
        </div>
        <p
          v-if="item.status == 2 && item.memo"
          class="record-memo"
        >
          {{ item.memo }}
        </p>
      </article>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Empty, Icon } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Empty).use(Icon);

export default {
	name: "Cashlist",
	data() {
		return {
			lang: this.$i18n.locale || "en_us",
			data: [],
			listShow: false,
		};
	},
	computed: {
		records() {
			return this.data || [];
		},
	},
	created() {
		this.$parent.footer("user");
	},
	mounted() {
		Fetch("/user/cash_search").then(r => {
			var list = r.data || [];

			this.showError(list.length);
			this.data = list;
		});
	},
	methods: {
		formatMoney(value) {
			var amount = value || 0;
			var mark = typeof this.utils_moneyMark === "function" ? this.utils_moneyMark() : "";

			return String(mark || "").replace(/\s+$/g, "") + " " + amount;
		},
		getCashStatusText(item) {
			if (String(item.status) === "1") {
				return this.$t("shopds.cashstat");
			}
			if (String(item.status) === "2") {
				return this.$t("shopds.cashstatfail");
			}
			return this.$t("shopds.cashstating");
		},
		getCashStatusClass(item) {
			if (String(item.status) === "1") {
				return "is-success";
			}
			if (String(item.status) === "2") {
				return "is-fail";
			}
			return "is-pending";
		},
		showError(len) {
			this.listShow = len === 0;
		},
	},
};
</script>

<style lang="less" scoped>
.record-page {
	min-height: 100vh;
	background: #111;
	color: #f6f6f6;
	padding-bottom: 80px;
	box-sizing: border-box;
}

.page-top {
	height: 44px;
	background: #111;
	color: #f6f6f6;
	border-bottom: 1px solid #242424;
	box-sizing: border-box;

	.back_left {
		filter: invert(1);
		opacity: 0.88;
	}

	.big_tit {
		color: #f6f6f6;
	}
}

.top-action {
	position: absolute;
	top: 7px;
	right: 16px;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 0;
	border-radius: 50%;
	background: rgba(101, 123, 233, 0.18);
	color: #8ea0ff;
	font-size: 18px;
	padding: 0;
}

.record-list {
	padding: 16px 16px 0;
}

.record-card {
	margin-bottom: 14px;
	padding: 17px 18px;
	border-radius: 12px;
	border: 1px solid #303030;
	background: #222;
	box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
	box-sizing: border-box;
}

.record-head,
.record-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-width: 0;
}

.record-title {
	min-width: 0;
	color: #f6f6f6;
	font-size: 14px;
	font-weight: 700;
	line-height: 22px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.record-money {
	flex: 0 0 auto;
	max-width: 52%;
	margin-left: 12px;
	font-size: 18px;
	font-weight: 700;
	line-height: 24px;
	overflow: hidden;
	text-align: right;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.record-money.is-outcome {
	color: #ff4a4a;
}

.record-row {
	margin-top: 12px;
	color: #9aa1aa;
	font-size: 13px;
	line-height: 20px;
}

.record-row span,
.record-row time {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.record-row time {
	margin-left: 14px;
	text-align: right;
}

.status-row {
	justify-content: flex-end;
}

.record-status {
	flex: 0 0 auto;
	font-size: 14px;
	line-height: 20px;
	text-align: right;
	white-space: nowrap;
}

.record-status.is-success {
	color: #12ed72;
}

.record-status.is-fail {
	color: #ff4a4a;
}

.record-status.is-pending {
	color: #8ea0ff;
}

.record-memo {
	margin-top: 12px;
	padding-top: 12px;
	border-top: 1px solid rgba(255, 255, 255, 0.06);
	color: #c6cad2;
	font-size: 13px;
	line-height: 20px;
	word-break: break-word;
}

/deep/ .van-empty {
	padding-top: 72px;
}

/deep/ .van-empty__description {
	color: #9aa1aa;
}


.basic_btn,
.history_coupon,
.wallet-btn.is-primary,
.allbtn {
  border: 0;
  background: linear-gradient(100deg, #657be9 0%, #8c52bd 100%) !important;
  color: #fff;
}


.page-top {
  background: #101010;
}

@media screen and (max-width: 374px) {
	.record-list {
		padding-right: 12px;
		padding-left: 12px;
	}

	.record-card {
		padding-right: 14px;
		padding-left: 14px;
	}

	.record-money {
		font-size: 16px;
	}
}
</style>
